import React, { useEffect } from 'react';
import { StatusBar } from 'expo-status-bar';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { Provider as PaperProvider, DefaultTheme } from 'react-native-paper';
import { AuthProvider } from './src/context/AuthContext';
import AppNavigator from './src/navigation/AppNavigator';
import { Platform } from 'react-native';

// Tema tanımlaması
const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: '#3498db',
    accent: '#f1c40f',
    background: '#f9f9f9',
    surface: '#ffffff',
    error: '#e74c3c',
  },
};

// Web için service worker kaydı
const registerServiceWorker = () => {
  if (Platform.OS === 'web' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/serviceWorker.js')
        .then(registration => {
          console.log('ServiceWorker başarıyla kaydedildi: ', registration.scope);
        })
        .catch(error => {
          console.log('ServiceWorker kaydı başarısız oldu: ', error);
        });
    });
  }
};

export default function App() {
  // Service worker'ı kaydet
  useEffect(() => {
    registerServiceWorker();
  }, []);
  
  return (
    <SafeAreaProvider>
      <PaperProvider theme={theme}>
        <AuthProvider>
          <AppNavigator />
        </AuthProvider>
        <StatusBar style="auto" />
      </PaperProvider>
    </SafeAreaProvider>
  );
}
